import React from 'react';
import { isAuthenticated } from './session';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const PrivateRoute = () => {
  const location = useLocation();
  return isAuthenticated() ? (
    <Outlet />
  ) : (
    <Navigate to={{ pathname: '/', state: { from: location } }} />
  );
};

export default PrivateRoute;
